(() => {
  // Check if already initialized
  if (window.shopByCollectionInitialized) return;
  window.shopByCollectionInitialized = true;

  const loadMoreProducts = sectionId => {
    const section = document.getElementById(`featured-collection-${sectionId}`);
    if (!section) return;

    const hiddenProducts = section.querySelectorAll('.js-product-item.hidden');
    const loadMoreBtn = section.querySelector('.js-load-more-btn');

    hiddenProducts.forEach(product => {
      product.classList.remove('hidden');
    });

    if (loadMoreBtn) {
      loadMoreBtn.style.display = 'none';
    }
  };

  const attachLoadMoreListeners = () => {
    // Use event delegation on document level to handle all load more buttons
    document.addEventListener('click', event => {
      if (event.target.classList.contains('js-load-more-btn')) {
        const sectionId = event.target.getAttribute('data-section-id');
        loadMoreProducts(sectionId);
      }
    });
  };

  const initializeShopByCollection = () => {
    attachLoadMoreListeners();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShopByCollection);
  } else {
    initializeShopByCollection();
  }
})();
